<template>

      <div class="rm" :ref="'rm_'+index">
        <div @click="selectRegistrationMethod(index)" class="rm-header row">
          <div class="row">
            <div class="col col-15 text-center"><input @input="selectRegistrationMethod(index)" class="input-radio" :id="'rm_'+index" name="rm" type="radio" :value="index"></div>
            <div class="col col-85">
              <label class="text-left" :for="'rm_'+index">
                <p class="mb-0 mt-0 lh-1-6"><strong>{{registration_method.name}}</strong></p>
                <p class="mb-0 mt-0 text-16 lh-1-6" v-if="this.generateDescription(registration_method)">{{this.generateDescription(registration_method)}}</p>
              </label>
            </div>
          </div>
        </div>
        <div class="rm-form p-30" v-if="selected==index">
          <div v-if="registration_method.registration_method_id==2">
            <div class="row mb-15">
              <input v-model="form.last_name" class="input-text rounded" type="text" placeholder="Last Name" />
            </div>
            <div class="row mb-15">
              <input v-model="form.room_number" class="input-text rounded" type="text" placeholder="Room Number" />
            </div>
          </div>
          <div v-if="registration_method.registration_method_id==3">
            <div class="row mb-15">
              <input v-model="form.email_address" class="input-text rounded" type="text" placeholder="Email" />
            </div>
          </div>
          <div v-if="registration_method.registration_method_id==4" class="row mb-15 p-rel">
            <input v-model="access_code" class="input-text rounded" type="text" placeholder="Access Code" />
            <span v-if="!access_code_valid" class="error-text">{{access_code_error_text}}</span>
          </div>
          <div class="mb-15">
            <button @click="emitRegistrationMethodData()" class="btn rounded" type="button" :style="'background: ' + color_background_button + '; color: ' + color_text_button">Continue</button>
          </div>
          <p class="text-center text-14 mb-0">By clicking continue you agree to the
            <span @click="selectTermsOfService(index)" class="text-link">Terms and Conditions</span>
          </p>
          <div class="terms-of-service text-left pt-20" v-if="selected_tos==index">
            <div v-html="registration_method.terms_of_service"></div>
            <div class="mt-30 text-center"><button class="btn-close" @click="selectTermsOfService(null)">CLOSE</button></div>
          </div>
        </div>
      </div> <!-- rm -->



</template>
<script>
export default {
  name: 'registration_method',
  props: ['index','selected','selected_tos','color_background_button','color_text_button','registration_method'],
  data(){
    return{
      access_code: null,
      access_code_valid: true,
      access_code_error_text: 'Required',
      clicked: false,
      form: {
        last_name: '',
        room_number: '',
        email_address: '',
      },
    }
  },
  watch: {
    'selected':function(){
      this.$el.querySelector( '#rm_' + this.index ).checked = (this.selected == this.index);
    }
  },
  mounted(){
    this.$el.querySelector( '#rm_' + this.index ).checked = (this.selected == this.index);
  },
  methods: {
    // Generate the description that appears below the Registration Method name
    generateDescription:function(rm){
      if(rm.type!='rateplan') return null;
      var description = '';
      if (parseInt(rm.price)==0) {
        description += 'Connect';
      } else {
        description += '$' + rm.price;
      }

      description += ' for ';

      if(rm.duration>=1440){
        if(rm.duration % 1440 > 0){
          description += ' more than ';
        }
        var whole_days = Math.floor(rm.duration / 1440);
        description += whole_days + ' day'
        if(whole_days > 1){
          description += 's';
        }
      } else if(rm.duration>=60){
        if(rm.duration % 60 > 0){
          description += ' more than ';
        }
        var whole_hours = Math.floor(rm.duration / 60);
        description += whole_hours + ' hour'
        if(whole_hours > 1){
          description += 's';
        }
      } else {
        description += rm.duration + ' minute'
        if(rm.duration > 1){
          description += 's';
        }
      }

      description += ' with ';
      if(rm.additional_devices>0){
        description += 'up to ' + rm.additional_devices + ' devices';
      } else {
        description += '1 device';
      }
      if(rm.speed_upload && rm.speed_download){
        description += ' (' + rm.speed_upload + ' Up / ' + rm.speed_download + ' Down)';
      }
      return description;
    },
    // Send selected Registration Method back to parent
    selectRegistrationMethod:function(index){
      this.$emit('changeSelected', index);
    },
    // Send selected Terms of Service back to parent
    selectTermsOfService:function(index){
      this.$emit('changeSelectedTOS', index);
    },
    // Manipulate and send registration method data back to parent
    emitRegistrationMethodData:function(){
      // If no access code set, show required text
      if(this.registration_method.type=='accesscode' && !this.access_code){
        this.access_code_valid = false;
        return;
      }
      if(this.clicked){
        return;
      }
      this.clicked = true;


      var emitted = {
        registration_method_id: this.registration_method.registration_method_id,
        rateplan_id: null,
        email_address: null,
        last_name: null,
        room_number: null,
        access_code: null,
      };
      if(this.registration_method.registration_method_id=='1'){
        emitted.rateplan_id = this.registration_method.id;
      } else if(this.registration_method.registration_method_id=='2'){
        emitted.rateplan_id = this.registration_method.id;
        emitted.last_name = this.form.last_name;
        emitted.room_number = this.form.room_number;
      } else if(this.registration_method.registration_method_id=='3'){
        emitted.rateplan_id = this.registration_method.id;
        emitted.email_address = this.form.email_address;
      } else if(this.registration_method.registration_method_id=='4'){
        emitted.access_code = this.access_code;
      }
      this.$emit('emitRegistrationMethodData', emitted);
    },

  }
}
</script>
<style scoped>

.rm a, .rm span.text-link { color: #000000; text-decoration: underline; cursor: pointer }
.rm .help-text { color: #000000; padding: 5px 0; font-size: 14px; font-style: italic; text-align: center; display: block; }
.rm .error-text { text-transform: uppercase; position: absolute; line-height: 1; right: 12px; top: 12px; padding: 8px 8px 7px 8px; background: red; color: #ffffff; border-radius: 3px; text-align: left; font-weight: bold; font-size: 12px; }
.rm .rm-header { background: #ffffff; border-top-width: 1px; border-top-style: solid; cursor: pointer; }
.rm .rm-form { background: #eeeeee; border-top-width: 1px; border-top-style: solid; }
.rm:last-child { border-bottom-width: 1px; border-bottom-style: solid; }
.rm .input-text { border: 1px solid #cccccc; color: #000000; overflow: visible;width: 100%;padding: 15px; font-size: 16px;}
.rm .input-text.rounded { border-radius: 6px; }
.rm .btn { background: #ffffff; border: 1px solid rgba(0,0,0,0.3); background: rgb(252,252,252); background: -moz-linear-gradient(top, rgba(252,252,252,1) 0%, rgba(232,232,232,1) 100%); background: -webkit-linear-gradient(top, rgba(252,252,252,1) 0%,rgba(232,232,232,1) 100%); background: linear-gradient(to bottom, rgba(252,252,252,1) 0%,rgba(232,232,232,1) 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#e8e8e8',GradientType=0 ); }
.rm .btn { width: 100%; padding: 20px; cursor: pointer; font-size: 20px; font-weight: bold; }
.rm .btn.rounded { border-radius: 6px; }
.rm label { display: inline-block; padding: 10px 30px 10px 0px; width: 100%; font-size: 18px; }
.rm label span { font-size: 16px; font-weight: normal; }
.rm .input-radio { display: inline-block; padding: 10px; }
</style>
